/**
 * Footer newsletter — hash-free redirect.
 *
 * Shopify's {% form 'customer' %} appends #<form-id> to the return_to URL,
 * causing the success page to scroll to the footer form.
 * We intercept the submit, POST the form data ourselves via fetch, then
 * navigate to /pages/newsletter-success without any hash.
 */
(function () {
  'use strict';

  function init() {
    var form = document.querySelector('.footer-newsletter');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      // Shopify generates action="/contact#footer-newsletter-form" — strip the hash.
      var action = (form.getAttribute('action') || '/contact').split('#')[0];
      var data = new FormData(form);

      fetch(action, {
        method: 'POST',
        body: data,
        credentials: 'same-origin'
      })
        .then(function () {
          window.location.href = '/pages/newsletter-success';
        })
        .catch(function () {
          // JS fetch failed — fall back to native submit (hash redirect may occur).
          form.removeEventListener('submit', arguments.callee);
          form.submit();
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
